var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dropdown-datepicker',{attrs:{"wrapperClass":"select field-block dropdown-date-time","allowFuture":_vm.allowFuture,"allowPast":_vm.allowPast,"default-date":_vm.value,"on-change":_vm.onChange,"minYear":1920}})}
var staticRenderFns = []

export { render, staticRenderFns }